module.exports = __webpack_public_path__ + "img/pic_simu1@2x.a8e33ad8.png";